export { default as useStyles } from "./useStyles";
